// frontend/packages/business-console/src/components/layout/DistrictModeGate.jsx
//
// Route wrapper for school district mode (districtMode.js): a page the mode
// hides redirects to Home instead of rendering, so a bookmark or an old link
// to /crm or /invoices does not open the sales stack. Renders the page while
// the tenant flags load (they are cached per business after the first load),
// so ordinary tenants never wait on this.

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { BusinessContext } from '../../contexts/BusinessContext';
import useTenantFeatures from '../../hooks/useTenantFeatures';
import { hiddenInDistrictMode } from './districtMode';

export default function DistrictModeGate({ pageKey, children }) {
  const { business } = useContext(BusinessContext);
  const { loading, features } = useTenantFeatures();
  if (!loading && hiddenInDistrictMode(pageKey, features)) {
    const home = business?.slug ? `/business/${business.slug}` : '/';
    return <Navigate to={home} replace />;
  }
  return children;
}
